export default __webpack_public_path__ + "static/media/Crypto_Native-IAMA.1079aaea.png";